<template>
  <div class="flex lg:flex-col sm:items-center justify-between mb-4">
    <radio-button
      :id="`${room.code}-${item.code}`"
      :value="item.code === currentMealPlan"
      :class="{ selected: item.code === currentMealPlan }"
      :name="`${room.code}-meal-plans`"
      @handle-checked="$emit('change', { field: 'mealPlan', value: item.code })"
    >
      <div
        class="lg:font-medium fs-14 flex items-center gap-1"
        style="transform: translateY(-1px)"
      >
        {{ item.name }}

        <tooltip
          v-if="description"
          namespace="hbtmealplans"
          :tooltip-id="item.code"
        >
          <template v-slot:trigger="{ show, hide, isShowing }">
            <span
              class="fs-14 text-black-light-4 ml-30 sm:ml-0 cursor-pointer inline-block"
              style="transform: translateY(2px)"
              @mouseenter="show"
              @mouseleave="hide"
              @touchstart="show"
            >
              <svg
                v-if="description"
                class="icon-question cursor-pointer"
                fill="currentColor"
                width="16"
                height="16"
              >
                <use xlink:href="/img/sprite.svg#ic_question" />
              </svg>
            </span>
          </template>

          <template v-slot:default="{ hide }">
            <div class="bg-white p-2 rounded tooltip-content">
              {{ getMealPlanDescription(item.code) }}
            </div>
          </template>
        </tooltip>
      </div>
    </radio-button>
    <span class="fs-14 text-black-light-4 ml-30 sm:ml-0">
      <currency-context v-if="item.priceDiff">
        <template v-slot="{ convert }">
          <span
            v-text="'+' + convert(applyRoomMarkup(room.code, item.priceDiff))"
          ></span>
        </template>
      </currency-context>
      <span v-else>included</span>
    </span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CurrencyContext from "../../core/CurrencyContext";
import RadioButton from "../../core/RadioButton";
import Tooltip from "../../core/Tooltip";

export default {
  props: ["item", "room", "currentMealPlan"],
  components: {
    RadioButton,
    Tooltip,
    CurrencyContext,
  },
  computed: {
    ...mapGetters(["getMealPlanDescription", "applyRoomMarkup"]),
    description() {
      return this.getMealPlanDescription(this.item.code);
    },
  },
};
</script>

<style scoped>
.tooltip-content {
  box-shadow: 0 0 15px #988888;
  font-size: 14px;
  width: 300px;
}

::v-deep input[type="radio"]:checked ~ .radio-label {
  color: unset !important;
}

::v-deep .radio-label::after {
  background-color: #1695a3 !important;
}

.selected ::v-deep .radio-label::before {
  border: 0.1em solid #1695a3 !important;
  margin-top: 1px;
}

.selected ::v-deep .radio-label::after {
  width: 0.6em;
  height: 0.6em;
  top: 0.3em;
  left: 0.3em;
  background-color: #6d9fb5;
  margin-top: 1px;
}

::v-deep .radio-label::before {
  border: 0.1em solid #222 !important;
}

@media (max-width: 600px) {
  .tooltip-content {
    width: 220px;
    left: 0;
  }
}
</style>
